import { render, staticRenderFns } from "./RoHHero.vue?vue&type=template&id=07c54263&scoped=true&"
import script from "./RoHHero.vue?vue&type=script&lang=js&"
export * from "./RoHHero.vue?vue&type=script&lang=js&"
import style0 from "./RoHHero.vue?vue&type=style&index=0&id=07c54263&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c54263",
  null
  
)

export default component.exports